'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var formik = require('formik');
var bumbag = require('bumbag');
var validate = require('@medipass/utils/validate-form');
var components_AddressField = require('../../components/AddressField.js');
require('@babel/runtime/helpers/extends');
require('@babel/runtime/regenerator');
require('@babel/runtime/helpers/asyncToGenerator');
require('react-loads-next');
require('use-debounce');
require('lodash/get');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var validate__default = /*#__PURE__*/_interopDefaultLegacy(validate);

var FormikAddressField = bumbag.formikField(components_AddressField["default"], {
  hasFieldWrapper: true,
  useValue: true
});
var MedicareDefaultAddress = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose__default["default"](MedicareDefaultAddress, _React$Component);

  function MedicareDefaultAddress() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "state", {
      temporaryAddressVisibility: 'false'
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "handleToggle", function (visibility) {
      _this.setState({
        temporaryAddressVisibility: visibility
      });
    });

    return _this;
  }

  var _proto = MedicareDefaultAddress.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var temporaryAddressVisibility = this.state.temporaryAddressVisibility;
    return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement("label", {
      className: "label"
    }, "Use your default address for this claim?"), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
      className: "control"
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.RadioGroupField, {
      orientation: "horizontal",
      name: "defaultAddressCheckBox" // @ts-expect-error TS(2339): Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
      ,
      onChange: function onChange(e) {
        return _this2.handleToggle(e.target.value);
      },
      value: temporaryAddressVisibility,
      options: [{
        label: 'Yes',
        value: 'false'
      }, {
        label: 'No',
        value: 'true'
      }]
    })), temporaryAddressVisibility === 'true' &&
    /*#__PURE__*/
    // @ts-expect-error TS(2322): Type '{ children: Element; backgroundColor: "white... Remove this comment to see the full error message
    React__default["default"].createElement(bumbag.Box, {
      backgroundColor: "white700",
      isFullWidth: true,
      marginTop: "major-2",
      padding: "major-2"
    }, /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      component: FormikAddressField,
      isRequired: true,
      name: "location",
      label: "Specify a temporary address",
      validate: validate__default["default"](validate.isRequired)
    })));
  };

  return MedicareDefaultAddress;
}(React__default["default"].Component);

exports.MedicareDefaultAddress = MedicareDefaultAddress;
exports["default"] = MedicareDefaultAddress;
